module.exports = function() {
  return new Worker(__webpack_public_path__ + "464fb41de3592600aefa.worker.js");
};